<eds-enhanced-filter
  *ngIf="filterGroup.filters?.length"
  [preTitle]="displayOptions.preTitle"
  [title]="displayOptions.title"
  [filters]="
    displayOptions.enableFilters
      ? displayOptions.isPreFiltered
        ? ''
        : filterGroup.filters
      : ''
  "
  [search]="displayOptions.enableSearch ? filterGroup.search : ''"
  [resetText]="getTranslation('resetFilters')"
  [chipsFilter]="filterGroup.chipsFilter"
  (searchValue)="onTermSearch($event)"
  [verticalAlignment]="verticalFilter"
  (dropdownSelected)="onSelectFilter($event)"
  (resetTriggered)="resetFilter($event)"
  (chipRemovedTriggered)="chipRemoved($event)"
></eds-enhanced-filter>
